import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";

@Component({
  selector: "app-points-calculation",
  templateUrl: "./points-calculation.component.html",
  styleUrls: ["./points-calculation.component.scss"],
})
export class PointsCalculationComponent implements OnInit {
  filters: any = {
    target_id: "",
    reason: "",
  };
  targetList: any = [];
  deleteLogList: any = [];
  page: number = 1;
  getPaginationCount: any;
  totalPages: any;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private modalService: NgbModal,
    public ngxService: NgxUiLoaderService
  ) {}

  ngOnInit() {
    this.getTargetlist();
    this.getDeleteTargetLog();
  }
  getTargetlist() {
    this.apiService.get(this.apiConfig.deleteTargetsList).subscribe(
      (res: any) => {
        this.targetList = res.data;
        console.log(res);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  getDeleteTargetLog() {
    this.apiService
      .getHeaders(this.apiConfig.getDeleteTargetLog + `?type=3`)
      .subscribe((res: any) => {
        this.deleteLogList = res.body.data;
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        this.totalPages = res.headers.get("X-Pagination-Per-Page");
        console.log(res);
      });
  }
  paginationClick(page) {
    this.page = page;
    this.getDeleteTargetLog();
  }
  submitData() {
    this.ngxService.start();
    console.log(this.filters);
    let payload = {
      target_id: this.filters.target_id,
      reason: this.filters.reason,
    };
    this.apiService
      .post(this.apiConfig.deleltePointCalculation, payload)
      .subscribe(
        (res: any) => {
          this.filters = {
            target_id: "",
            reason: "",
            type: "",
            file: "",
          };
          console.log(res);
          this.ngxService.stop();
        },
        (err: any) => {
          this.filters = {
            target_id: "",
            reason: "",
            type: "",
            file: "",
          };
          this.ngxService.stop();
        }
      );
  }
  isFormValid(): boolean {
    if (!this.filters.target_id || !this.filters.reason) {
      return false;
    }
    return true;
  }
  type: any;
  responseData: any = [];
  detailedData(modalRef: any, data: any, type: any) {
    this.type = type;
    this.responseData = data;
    this.modalService.open(modalRef, { centered: true });
  }
}
